import veiculosApi from "@/app/services/veiculos";
import veiculo from "@/app/store/models/veiculo";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    veiculo: {...veiculo},
    veiculos: [],
    busca: "",
    total_itens: 0,
    paginacao: PAGINATION_OPTIONS
  },

  mutations: {
    LISTAR(state, veiculos) {
      state.veiculos = veiculos;
    },

    ABRIR(state, veiculo) {
      state.veiculo = veiculo;
    },

    ADICIONAR(state, veiculo) {
      state.veiculos.push(veiculo);
    },

    ATUALIZAR(state, veiculo) {
      let index = state.veiculos.findIndex(veiculo_ => veiculo_.id == veiculo.id);
      if (index > -1) {
        state.veiculos.splice(index, 1, veiculo);
      }
    },

    EXCLUIR(state, id) {
      let index = state.veiculos.findIndex(veiculo => veiculo.id == id);
      if (index > -1) {
        state.veiculos.splice(index, 1);
      }
    },

    SET_BUSCA(state, busca) {
      state.busca = busca;
    },

    SET_PAGE(state, page) {
      state.paginacao.page = page;
    },

    SET_TOTAL_ITENS(state, total_itens) {
      state.total_itens = total_itens;
    },

    UPDATE_PAGINACAO(state, paginacao) {
      state.paginacao = paginacao;
    },

    ZERAR(state) {
      state.veiculo = {...veiculo};
    }
  },

  actions: {
    async listar({ commit, state }) {
      commit('LOADING_ON', null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.paginacao;

      const paginacao = {
        page, 
        itemsPerPage,
        sortBy: sortBy[0], 
        sortDesc: sortDesc[0]
      }

      if (state.busca) {
        paginacao.busca = state.busca;
      }

      let response = await veiculosApi.listar(paginacao);
      commit('LISTAR', response.data);
      commit('SET_TOTAL_ITENS', response.total);
      commit('LOADING_OFF', null, { root: true });
    },

    async abrir({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      let veiculo = await veiculosApi.abrir(id);
      commit('ABRIR', veiculo);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvar({ commit }, veiculo) {
      let novoveiculo = await veiculosApi.salvar(veiculo);
      commit('ADICIONAR', novoveiculo);
    },

    async atualizar({ commit }, veiculo) {
      await veiculosApi.atualizar(veiculo);
      commit('ATUALIZAR', veiculo);
    },

    async excluir({ commit }, id) {
      await veiculosApi.excluir(id);
      commit('EXCLUIR', id);
    },

  }
}
